import Vue from 'vue'
import SealListCom from '../components/fileEseal/sealList'
let checkSeal
// 通过Vue.extend将组件包装成一个子类
const SealListConstructor = Vue.extend(SealListCom)
const showSeal = (userInfo, serverUrl = "http://116.62.162.13:9297") => {
  // 如果组件已渲染，则返回即可
  // 要挂载的元素
  const parent = document.body
  // 通过构造函数初始化组件 相当于 new Vue()
  const instance = new SealListConstructor({
    el: document.createElement('div')
  })
  instance.serverUrl = serverUrl
  instance.userInfo = userInfo
  instance.reFindPersonalSealList()
  instance.getCompList()
  parent.appendChild(instance.$el)
  Vue.nextTick(() => {
    instance.show = true
  })
  checkSeal = instance
  return instance
}

export default function(userInfo, serverUrl) {
  return () => {
    return showSeal(userInfo, serverUrl)
  }
}